
import Collection from "./core/collection.js";
import ProofGroup from "./core/proofGroup.js";
import Token from "./core/token.js";
import Proof from "./core/proof.js";
import Asset from "./core/asset.js";
import Personal from "./core/personal.js";


export default {Collection, ProofGroup, Token, Asset, Personal, Proof};
